import { gql } from '@apollo/client';
export const EXPORT_DOCUMENT_ALLOWED_STATE_RIGHTS_LIST = gql`
  mutation ExportAutomaticStateTransitions($input: AutomaticStateTransitionFilterMutationExportInput) {
    exportAutomaticStateTransitions(input: $input) {
      fileId
      fileName
      filePath
      fileBytes
    }
  }
`;

export const AUTOMATICSTATETRANSITION_SAVE = gql`
  mutation AutomaticStateTransition($input: AutomaticStateTransitionSave) {
    automaticStateTransition(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const AUTOMATICSTATETRANSITIONRULE_SAVE = gql`
  mutation AutomaticStateTransitionRule($input: AutomaticStateTransitionRuleSave) {
    automaticStateTransitionRule(input: $input) {
      commandId
      correlationId
    }
  }
`;
export const AUTOMATICSTATETRANSITIONRULE_DELETE = gql`
  mutation Mutation($input: AutomaticStateTransitionRuleDelete) {
    automaticStateTransitionRuleDelete(input: $input) {
      commandId
      correlationId
    }
  }
`;
